import { supabase } from './supabase';

export async function updateRecord(
  table: string,
  id: string,
  data: Record<string, unknown>
): Promise<void> {
  const { error } = await supabase.from(table).update(data).eq('id', id);
  if (error) throw error;
}

export async function insertRecord(
  table: string,
  data: Record<string, unknown>
): Promise<string> {
  const { data: result, error } = await supabase
    .from(table)
    .insert(data)
    .select('id')
    .single();
  if (error) throw error;
  return result.id;
}

export async function softDeleteRecord(
  table: string,
  id: string
): Promise<void> {
  const { error } = await supabase
    .from(table)
    .update({ is_deleted: true })
    .eq('id', id);
  if (error) throw error;
}

// Why: Amendment saves are a two-step operation — update dsr_reports
// status/tracking fields, then create an annotation with the reason.
// The annotation uses type='amendment' which the SSR insert policy
// (ssr_amendment_insert) allows SSRs to create on their own DSRs.
export async function saveAmendmentRecord(
  dsrId: string,
  amendedBy: string,
  tenantId: string,
  reason: string
): Promise<void> {
  const { error: reportError } = await supabase
    .from('dsr_reports')
    .update({
      status: 'amended',
      amended_by: amendedBy,
      amended_at: new Date().toISOString(),
    })
    .eq('id', dsrId);
  if (reportError) throw reportError;

  const { error: annotationError } = await supabase
    .from('dsr_annotations')
    .insert({
      dsr_report_id: dsrId,
      tenant_id: tenantId,
      annotation_type: 'amendment',
      body: reason,
      created_by: amendedBy,
    });
  if (annotationError) throw annotationError;
}
